import { useSyncExternalStore } from "react";
import type { Category, EventId } from "../../../shared/types";

// Reactive store that mirrors the event form state so the calendar can
// render a live preview (time range, category color, title) while editing.

export interface FormPreview {
  readonly eventId: EventId | null; // null = new event (slot creation)
  readonly category: Category;
  readonly startTime: string;
  readonly endTime: string;
  readonly date: string;
  readonly allDay: boolean;
  readonly title: string;
}

let current: FormPreview | null = null;
const listeners = new Set<() => void>();

function emit() {
  for (const fn of listeners) fn();
}

export function setFormPreview(preview: FormPreview | null) {
  current = preview;
  emit();
}

export function patchFormPreview(patch: Partial<FormPreview>) {
  if (!current) return;
  current = { ...current, ...patch };
  emit();
}

export function clearFormPreview() {
  if (!current) return;
  current = null;
  emit();
}

export function useFormPreview(): FormPreview | null {
  return useSyncExternalStore(
    (cb) => {
      listeners.add(cb);
      return () => listeners.delete(cb);
    },
    () => current,
  );
}
